export abstract class BaseModel<T> {

    constructor(value?: T)  {
        Object.keys(value || {}).forEach(key => this[key] = value[key])
    }

}